import React, { useEffect, useState } from 'react';
import { useParams, useNavigate } from 'react-router-dom';
import axios from 'axios';
import Chart from 'chart.js/auto';
import '../css/LinkDetails.css'; // Add a scoped CSS file for styling

const LinkDetails = () => {
  const { shortUrl } = useParams(); // Extract shortUrl from the URL
  const navigate = useNavigate(); // For navigating back
  const [linkDetails, setLinkDetails] = useState(null);
  const [error, setError] = useState('');

  // Fetch link details
  useEffect(() => {
    const fetchLinkDetails = async () => {
      try {
        const response = await axios.get(
          `https://urlshortener-serverside.onrender.com/api/links/${shortUrl}/details`
        );
        setLinkDetails(response.data); // Set link details
      } catch (err) {
        setError(err.response?.data?.error || 'Failed to fetch link details.');
      }
    };
    fetchLinkDetails();
  }, [shortUrl]);

  // Render chart
  const renderChart = (canvasId, data, label, color) => {
    const ctx = document.getElementById(canvasId)?.getContext('2d');
    if (ctx) {
      new Chart(ctx, {
        type: 'line',
        data: {
          labels: data.map((entry) => new Date(entry.timestamp).toLocaleDateString()),
          datasets: [
            {
              label,
              data: data.map((entry) => entry.value),
              backgroundColor: color,
              borderColor: color,
              borderWidth: 2,
              fill: false,
            },
          ],
        },
        options: {
          responsive: true,
          plugins: {
            legend: {
              display: true,
              position: 'top',
            },
          },
          scales: {
            x: {
              title: { display: true, text: 'Date' },
            },
            y: {
              title: { display: true, text: 'Count' },
              beginAtZero: true,
            },
          },
        },
      });
    }
  };

  // Generate charts after data fetch
  useEffect(() => {
    if (linkDetails) {
      if (linkDetails.clickTimestamps) {
        renderChart('clicksOverTimeChart', linkDetails.clickTimestamps, 'Clicks Over Time', '#4CAF50');
      }
      if (linkDetails.uniqueVisitors) {
        renderChart('uniqueVisitorsChart', linkDetails.uniqueVisitors, 'Unique Visitors Over Time', '#36A2EB');
      }
    }
  }, [linkDetails]);

  // Handle loading or error states
  if (error) {
    return <div className="error">{error}</div>;
  }

  if (!linkDetails) {
    return <div className="loading">Loading...</div>;
  }

  return (
    <div className="link-details-container">
      <button className="back-button" onClick={() => navigate(-1)}>
        &lt; Back
      </button>

      <div className="details-header">
        <h1>Details for {shortUrl}</h1>
      </div>

      <div className="details-content">
        <p>
          <strong>Long URL:</strong>{' '}
          <a href={linkDetails.longUrl} target="_blank" rel="noopener noreferrer" className="link">
            {linkDetails.longUrl}
          </a>
        </p>
        <p>
          <strong>Total Clicks:</strong> {linkDetails.clicks}
        </p>
        <p>
          <strong>Unique Visitors:</strong> {linkDetails.uniqueVisitors.length || 0}
        </p>
        <p>
          <strong>Created On:</strong>{' '}
          {new Date(linkDetails.createdAt).toLocaleDateString()}
        </p>
      </div>

      {/* Chart Section */}
      <div className="chart-section">
        <div className="chart-container">
          <h3>Clicks Over Time</h3>
          <canvas id="clicksOverTimeChart"></canvas>
        </div>
        <div className="chart-container">
          <h3>Unique Visitors Over Time</h3>
          <canvas id="uniqueVisitorsChart"></canvas>
        </div>
      </div>
    </div>
  );
};

export default LinkDetails;
